import * as React from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Divider, InputAdornment, Typography } from '@mui/material';
import TextFieldComponent from '../../../components/form/TextFieldComponent';
import { roundToTwo, roundToFour } from '../../../utils/storageUtil';
interface TotalComponentProps {
  billableFormItems: any[];
  companyDetails: any;
  projectForm: any;
  viewOnly: boolean;
  overheads: number;
  overheadPercentage: any;
  handleOverHeads(num: number): void;
  handleOverHeadPercentage(num: number): void;
  projectPercentage: number;
  contigencyPercentage: number;
  projectMargin: number;
  handleProjectPercentage(num: number): void;
  handleContigencyPercentage(num: number): void;
  handleProjectMargin(num: number): void;
  GST: number;
  GSTPrice?: number;
}
const TotalComponent: React.FC<TotalComponentProps> = ({
  billableFormItems,
  companyDetails,
  projectForm,
  viewOnly,

  overheads,
  overheadPercentage,
  handleOverHeads,
  handleOverHeadPercentage,
  projectPercentage,
  contigencyPercentage,
  projectMargin,
  handleProjectPercentage,
  handleContigencyPercentage,
  handleProjectMargin,
  GST,
  GSTPrice,
}) => {
  const [resourceTotal, setResourceTotal] = React.useState({});
  const [overheadPercent, setOverheadPercent] = React.useState<any>(
    overheadPercentage ? overheadPercentage.toString() : overheadPercentage
  );
  React.useEffect(() => {
    if (billableFormItems.length > 0) {
      generateTotal(billableFormItems);
    } else {
      setResourceTotal(0.0);
    }
  }, [billableFormItems]);
  React.useEffect(() => {
    if (projectForm.cost && overheadPercent) {
      calculateIndirectCost(overheadPercent);
    }
  }, [projectForm.cost, overheadPercent]);

  // Recalculate Project Margin percentage when overheads or contingencies change
  React.useEffect(() => {
    if (projectMargin) {
      calculateProjectMarginPercentage(projectMargin);
    }
  }, [overheads, contigencyPercentage]);
  // React.useEffect(() => {
  //   if (companyDetails) {
  //     if (companyDetails.financial.length > 0) {
  //       setOverheadPercent(companyDetails.financial[0].overheadPercent);
  //     }
  //   }
  // }, [companyDetails]);
  const generateTotal = (itemsData: any) => {
    const totals = itemsData.reduce((acc: any, item: any) => {
      if (item.resources && item.resources.length > 0) {
        item.resources.forEach((detail: any) => {
          const price =
            parseFloat(detail['items'][0]['price']) *
            parseInt(detail['items'][0]['quantity']);
          const resourceType =
            typeof detail['resourceType'] === 'object'
              ? detail['resourceType']['name']
              : detail['resourceType'];
          const numericCost = price;
          if (!acc[resourceType]) {
            acc[resourceType] = 0;
          }
          acc[resourceType] += numericCost;
        });
      }
      return acc;
    }, {});

    return setResourceTotal(totals);
  };
  const calculateIndirectCost = (percentageValue: any) => {
    handleOverHeads(parseFloat(getOverheadPercentageValue(percentageValue)));
  };
  const getDirectCostPercentage = (value: any) => {
    if (value) {
      if (parseFloat(projectForm.cost) > 0) {
        const percentage =
          (parseFloat(value) * 100) /
          (projectForm.cost ? parseFloat(projectForm.cost) : 0);
        return roundToTwo(percentage);
      } else {
        return '0';
      }
    } else {
      return 0.0;
    }
  };
  const handleInputChange = (e: any) => {
    const value = e.target.value.trim();
    const parsedValue = value === '' ? 0 : parseFloat(value);
    console.log(parsedValue, '-->>>>>>>');
    if (!isNaN(parsedValue)) {
      if (e.target.name === 'contigencyPercentageField') {
        const truncatedValue = roundToTwo(parsedValue);
        handleContigencyPercentage(truncatedValue);
        // Recalculate Project Margin percentage based on margin amount
        calculateProjectMarginPercentage(projectMargin);
      }
      if (e.target.name === 'projectPercentageField') {
        const truncatedValue = roundToFour(parsedValue);
        handleProjectPercentage(truncatedValue);
        getProjectPercentageValue(truncatedValue);
      }
      if (e.target.name === 'projectMarginField') {
        handleProjectMargin(parsedValue);
        calculateProjectMarginPercentage(parsedValue);
      }
      if (e.target.name === 'overheadPercent') {
        const truncatedValue = roundToTwo(parsedValue);
        setOverheadPercent(truncatedValue);
        calculateIndirectCost(truncatedValue);
        handleOverHeadPercentage(truncatedValue);
        // Recalculate Project Margin percentage based on margin amount
        calculateProjectMarginPercentage(projectMargin);
      }
    }
  };
  const calculateProjectMarginPercentage = (projectPercentageTxt: any) => {
    const subTotal =
      (overheads ? overheads : 0) +
      parseFloat(getContigencyPercentageValue()) +
      parseFloat(projectForm.cost ? projectForm.cost : '0');
    const percentage =
      ((projectPercentageTxt ? projectPercentageTxt : 0) * 100) / subTotal;
    handleProjectPercentage(percentage);
  };
  const getProjectPercentageValue = (projectPercentageTxt: any) => {
    const subTotal =
      (overheads ? overheads : 0) +
      parseFloat(getContigencyPercentageValue()) +
      parseFloat(projectForm.cost ? projectForm.cost : '0');
    const percentage =
      ((projectPercentageTxt ? projectPercentageTxt : 0) * subTotal) / 100;
    handleProjectMargin(percentage);
    return roundToTwo(percentage);
  };
  const getContigencyPercentageValue = () => {
    // console.log(projectForm.cost, '---projectForm.cost->>>');
    // console.log(contigencyPercentage, '---contigencyPercentage->>>');
    const subTotal = parseFloat(projectForm.cost ? projectForm.cost : '0');
    // console.log('contigencyPercentage == ' + contigencyPercentage);
    const percentage =
      ((contigencyPercentage ? contigencyPercentage : 0) * subTotal) / 100;
    return roundToTwo(percentage);
  };
  const getOverheadPercentageValue = (overheadPercentage: any) => {
    const subTotal = parseFloat(projectForm.cost ? projectForm.cost : '0');
    const percentage =
      ((overheadPercentage ? parseFloat(overheadPercentage) : 0) * subTotal) /
      100;
    return roundToTwo(percentage);
  };
  const getSubmissionPrice = () => {
    const subTotal =
      (overheads ? overheads : 0) +
      parseFloat(getContigencyPercentageValue()) +
      parseFloat(projectForm.cost ? projectForm.cost : '0');
    const percentage =
      ((projectPercentage ? projectPercentage : 0) * subTotal) / 100;
    return subTotal + percentage;
  };
  const getGST = () => {
    if (GSTPrice) return Number(GSTPrice);
    return (getSubmissionPrice() * GST) / 100;
  };
  return (
    <Box sx={{ padding: 4 }}>
      {/* Direct Costs */}
      <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Direct Cost
        </Typography>

        {Object.entries(resourceTotal).map(([key, value]: any) => (
          <Grid
            container
            spacing={2}
            key={key + '_tottla'}
            sx={{ marginBottom: 1 }}
          >
            <Grid size={6}>
              <Typography>{key}</Typography>
            </Grid>
            <Grid size={3} sx={{ textAlign: 'right' }}>
              <Typography>{getDirectCostPercentage(value)}%</Typography>
            </Grid>
            <Grid size={3} sx={{ textAlign: 'right' }}>
              <Typography>${roundToTwo(value)}</Typography>
            </Grid>
          </Grid>
        ))}
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography fontWeight="bold">Direct Subtotal</Typography>
          <Typography fontWeight="bold">
            ${projectForm.cost ? roundToTwo(projectForm.cost) : 0.0}
          </Typography>
        </Box>
      </Box>

      {/* Indirect Costs */}
      <Box>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Indirect Cost
        </Typography>

        <Grid
          container
          spacing={2}
          key={'indirectCost_grid'}
          sx={{ marginBottom: 1 }}
        >
          <Grid size={6}>
            <Typography>{'Overheads'}</Typography>
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            {viewOnly === true && (
              <Typography>{roundToTwo(overheadPercentage)}%</Typography>
            )}
            {viewOnly === false && (
              <TextFieldComponent
                label=""
                keyName="overheadPercent"
                name="overheadPercent"
                value={roundToTwo(overheadPercentage).toString()}
                onChange={handleInputChange}
                errorStr={''}
                isRequired={false}
                type="number"
                boxStyle={{
                  width: '100px',
                  marginTop: '-5px',
                  marginLeft: 'auto',
                }}
                suffix={<InputAdornment position="end">%</InputAdornment>}
                style={{ width: '100px' }}
              />
            )}
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            <Typography>${overheads}</Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          key={'indirectCost_grid_contigencies'}
          sx={{ marginBottom: 1 }}
        >
          <Grid size={6}>
            <Typography>{'Contigencies'}</Typography>
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            {viewOnly === false && (
              <TextFieldComponent
                label=""
                keyName="contigencyPercentageField"
                name="contigencyPercentageField"
                value={roundToTwo(contigencyPercentage).toString()}
                onChange={handleInputChange}
                errorStr={''}
                isRequired={false}
                type="number"
                boxStyle={{
                  width: '100px',
                  marginTop: '-5px',
                  marginLeft: 'auto',
                }}
                suffix={<InputAdornment position="end">%</InputAdornment>}
                style={{ width: '100px' }}
              />
            )}
            {viewOnly === true && (
              <Typography>{roundToTwo(contigencyPercentage)}%</Typography>
            )}
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right', mt: 2 }}>
            <Typography style={{ marginLeft: 'auto' }}>
              ${parseFloat(getContigencyPercentageValue())}
            </Typography>
          </Grid>
        </Grid>

        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography fontWeight="bold">Indirect Subtotal</Typography>
          <Typography fontWeight="bold">
            $
            {roundToTwo(
              roundToTwo(overheads) + roundToTwo(getContigencyPercentageValue())
            )}
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            marginTop: '20px',
            fontSize: '18px',
            justifyContent: 'space-between',
            padding: '8px',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography fontWeight="bold" fontSize={'20px'}>
            Subtotal
          </Typography>
          <Typography fontWeight="bold" fontSize={'20px'}>
            $
            {roundToTwo(
              (overheads ? overheads : 0) +
                parseFloat(getContigencyPercentageValue()) +
                roundToTwo(projectForm.cost ? projectForm.cost : '0')
            )}
          </Typography>
        </Box>

        <Grid
          container
          spacing={2}
          key={'projectPercentage'}
          sx={{ marginBottom: 1, marginTop: '20px', alignItems: 'center' }}
        >
          <Grid size={6}>
            <Typography>{'Project Margin'}</Typography>
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            {viewOnly === false && (
              <TextFieldComponent
                label=""
                keyName="projectPercentageField"
                name="projectPercentageField"
                value={roundToFour(projectPercentage).toString()}
                onChange={handleInputChange}
                errorStr={''}
                isRequired={false}
                type="number"
                boxStyle={{
                  width: '150px',
                  marginLeft: 'auto',
                  marginBottom: 0,
                }}
                suffix={<InputAdornment position="end">%</InputAdornment>}
                style={{ width: '150px' }}
              />
            )}
            {viewOnly && (
              <Typography>{roundToTwo(projectPercentage)}%</Typography>
            )}
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            {viewOnly === false && (
              <TextFieldComponent
                label=""
                keyName="projectMarginField"
                name="projectMarginField"
                value={roundToTwo(projectMargin).toString()}
                onChange={handleInputChange}
                errorStr={''}
                isRequired={false}
                type="number"
                boxStyle={{
                  width: '150px',
                  marginLeft: 'auto',
                  marginBottom: 0,
                }}
                style={{ width: '150px' }}
                prefix={<InputAdornment position="start">$</InputAdornment>}
              />
            )}
            {viewOnly && (
              <Typography fontWeight="bold">
                ${roundToTwo(projectMargin)}
              </Typography>
            )}
          </Grid>
        </Grid>

        <Grid
          container
          spacing={2}
          key={'projectPercentage_submissinprie'}
          sx={{ marginBottom: 1 }}
        >
          <Grid size={6}>
            <Typography marginTop={'20px'}>{''}</Typography>
          </Grid>
          {/* <Grid size={3} sx={{ textAlign: "right" }}>
             
            </Grid> */}
          <Grid
            size={6}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography style={{ marginLeft: 'auto' }}>
              Submission Price
            </Typography>
            <Typography style={{ marginLeft: 'auto', fontWeight: 'bold' }}>
              ${roundToTwo(getSubmissionPrice())}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          key={'projectPercentage_gst_price'}
          sx={{ marginBottom: 1 }}
        >
          <Grid size={6}>
            <Typography marginTop={'20px'}>{''}</Typography>
          </Grid>
          {/* <Grid size={3} sx={{ textAlign: "right" }}>
             
            </Grid> */}
          <Grid
            size={6}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography style={{ marginLeft: 'auto' }}>GST</Typography>
            <Typography style={{ marginLeft: 'auto', fontWeight: 'bold' }}>
              ${roundToTwo(getGST())}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            marginTop: '20px',
            fontSize: '18px',
            justifyContent: 'space-between',
            padding: '8px',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography fontWeight="bold" fontSize={'20px'}>
            Price incl. GST
          </Typography>
          <Typography fontWeight="bold" fontSize={'20px'}>
            $
            {roundToTwo(
              roundToTwo(getSubmissionPrice()) + roundToTwo(getGST())
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default TotalComponent;
